/* eslint-disable no-undef */
import popup from "./Popup";
import { serializeArray } from "../util/utils";
import { blockEl, unblockEl } from "./Block";
// import Toasts from "./Toasts";

const { __ } = wp.i18n;

export default class AjaxAddToCartVariation {
  constructor() {
    if ( typeof wc_add_to_cart_params === "undefined" ) {
      return false;
    }

    this.form = document.querySelector( '.variations_form' );
    if ( ! this.form ) {
      return;
    }

    this.runRequest = false;

    window.palram = window.palram || {}
    // this.toast = window.palram.toast || new Toasts();
    this.variation = {};

    // Handlers
    this.addHandlers();
  }

  addHandlers() {
    document.body.addEventListener( 'submit', this.onSubmitHandler.bind( this ) );
    $( '.variations_form' ).on( 'show_variation', ( evn, variation ) => {
      this.variation = variation;
    } );

    // $(document.body).on('removed_from_cart', this.onRemoveFromCart.bind(this));
  }

  async onSubmitHandler( event ) {
    if ( event.target.classList.contains( 'variations_form' ) ) {
      event.preventDefault();
      await this.onFormSubmit( event.target );
    }
  }

  async onFormSubmit( form ) {
    if ( ! form || this.runRequest ) {
      return;
    }
    this.runRequest = true;
    blockEl( this.form )

    const addToCartBtn = form.querySelector( 'button[type=submit]' );
    addToCartBtn.setAttribute( 'disabled', 'disabled' );

    let data = {
      action: 'palram_woocommerce_add_to_cart',
      secure: palram.nonces.add_to_cart_nonce,
    }

    serializeArray( form ).map( attr => {
      if ( attr.name !== 'add-to-cart' ) {
        if ( attr.name.endsWith( '[]' ) ) {
          // console.log(attr);
        } else {
          data[ attr.name ] = attr.value;
        }
      }
    } );

    let response = await this.addToCartRequest( data );

    try {
      if ( ! response ) {
        return;
      }

      this.addToCartSuccess( response );
      $( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash, $( addToCartBtn ), data ] );

    } catch ( e ) {
      console.log( e );
    } finally {
      unblockEl( this.form );
      this.runRequest = false;
      if ( addToCartBtn.disabled ) {
        addToCartBtn.removeAttribute( 'disabled' );
      }

      if ( ! response.error ) {
        this.onChangeCartWidget();
      }
    }
  }

  addToCartSuccess( response ) {
    if ( ! response.error ) {
      if ( wc_add_to_cart_params.cart_redirect_after_add === 'yes' ) {
        window.location = wc_add_to_cart_params.cart_url;
        return;
      }
    } else {
      let notice = '';
      for( let message of response.messages ) {
        notice = message.notice;
      }

      this.onLoadWarningPopup();
    }

    return false;
  }

  onLoadWarningPopup() {
    popup.open( {
      title: __( 'Oh no...', 'canopia' ),
      type: 'warning',
      message: `<p>${ palram.i18n_cannot_add_to_cart_message }</p>`,
      link: {
        url: wc_add_to_cart_params.cart_url,
        text: wc_add_to_cart_params.i18n_view_cart,
      },
    } );
  }

  async addToCartRequest( data ) {
    return $.ajax( {
      method: 'POST',
      url: wc_add_to_cart_params.ajax_url,
      data,
    } );
  }

  onChangeCartWidget() {
    // Open cart widget after success product added to cart
    document.body.dispatchEvent( new CustomEvent( 'palram_open_cart_widget' ) );
    let closeTimer;

    if ( closeTimer !== 'undefined' ) {
      clearTimeout( closeTimer );
    }

    closeTimer = setTimeout( () => {
      // Close cart widget after success finally product added to cart
      document.body.dispatchEvent( new CustomEvent( 'palram_close_cart_widget' ) );
    }, 5000 );
  }
}
